module.exports = __webpack_public_path__ + "static/media/app-store-blue.483a50ae.svg";